"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcCardSelectV2Behavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var bc_abstract_dropdown_behavior_1 = require("../bc-dropdown/bc-abstract-dropdown-behavior");
var input_constants_1 = require("../input/input-constants");
var bc_card_product_v2_constants_1 = require("../bc-card-product-v2/bc-card-product-v2-constants");
var bc_card_select_v2_constants_1 = require("./bc-card-select-v2-constants");
var bc_card_product_v2_behavior_1 = require("../bc-card-product-v2/bc-card-product-v2-behavior");
var bc_abstract_dropdown_constants_1 = require("../bc-dropdown/bc-abstract-dropdown-constants");
var bc_modal_constants_1 = require("../bc-modal/bc-modal-constants");
var BcCardSelectV2Behavior = (function (_super) {
    __extends(BcCardSelectV2Behavior, _super);
    function BcCardSelectV2Behavior() {
        var _this = _super.call(this) || this;
        _this.activeElement = null;
        _this.BcCardProductV2Behavior = null;
        _this.placeHolderStyle = [];
        _this.subtitleStyle = [];
        _this.fieldsToFilter = [];
        _this.messageNotData = bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_MESSAGENOTDATA;
        _this.maxHeightDropdown = bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_INIT_MAX_HEIGHT;
        _this.hideArrowIcon = false;
        _this.iconNotDataStyle = [];
        _this.labelNotDataStyle = [];
        return _this;
    }
    BcCardSelectV2Behavior.prototype._setUp = function () {
        this.setDropDownConfiguration();
        this.setupPlaceHolder();
        this.setIniText(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_MESSAGE_HOLDER);
        this.setSubtitleText(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_MESSAGE_SUBTITLE);
        this.getDropdownContent();
        _super.prototype._setUp.call(this);
        this.createItems();
        this.setMaxHeightDropdown(this.maxHeightDropdown);
        this.setEventListeners();
        this.setupAccessibility();
        this.markItemByIndex(this.defaultIndex);
    };
    BcCardSelectV2Behavior.prototype.setDropDownConfiguration = function () {
        this.setConfig({
            toggleClass: bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_TOGGLE_CLASS_V2,
            toggleActiveClass: bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_ACTIVE_TOGGLE_CLASS_V2,
            contentClass: bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_CLASS_V2,
            contentActiveClass: bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_ACTIVE_CLASS_V2,
            itemClass: bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_ITEM_CLASS_V2,
            triangleClass: bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_ITEM_CLASS_V2,
            extraToggles: [
                {
                    node: this.input,
                    events: ['focus'],
                },
            ],
            toggleEvents: ['click', 'input'],
            mainClass: bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_CLASS_V2,
            mainActiveClass: bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_ACTIVE_CLASS_V2,
            static: true,
            isPopUp: false,
            parentWidth: false,
            onlyBottomPosition: true,
            noOpenDropdown: this._noOpenDropdown
        });
    };
    BcCardSelectV2Behavior.prototype.getDropdownContent = function () {
        this.getDropdownParent();
        this.getDropdownBody();
        if (this.dropdownButtonConfig) {
            this.getDropdownFooter();
        }
    };
    BcCardSelectV2Behavior.prototype.setDisable = function (status) {
        var controlContent = this.mySelf;
        if (status) {
            this.closeDropdown();
            controlContent.classList.add(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_CONTROL_DISABLED_CLASS_V2);
            this.disabled = true;
        }
        else {
            controlContent.classList.remove(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_CONTROL_DISABLED_CLASS_V2);
            this.disabled = false;
        }
    };
    BcCardSelectV2Behavior.prototype.createItems = function () {
        var _this = this;
        if (this.itemsConfig && this.itemsConfig.length) {
            this.dropdownItems = [];
            this.itemsConfig.forEach(function (itemObj, i) {
                var li = _this.createCardItem(itemObj);
                _this.dropdownItems[i] = li;
                _this.dropdownItems[i].id = itemObj.value.toString();
            });
            var bodyContent = this.dropdownContent.querySelector(("*[class~='".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_BODY_CLASS_V2, "']")));
            bodyContent.innerHTML = '';
            bodyContent.appendChild((0, helpers_1.createElement)({
                element: common_constants_1.BcCommonConstants.UL_TAG,
                classList: [bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_CONTENT_ITEM_CLASS],
                children: this.dropdownItems.map(function (item) {
                    item.id = "".concat(_this.mySelf.id, "-item-value-").concat(item.id);
                    return item;
                })
            }));
        }
    };
    BcCardSelectV2Behavior.prototype.setItems = function (items, fieldsToFilter) {
        this.cleanItems();
        this.fieldsToFilter = fieldsToFilter;
        this.itemsConfig = items;
        if (items.length == 0) {
            this.restoreFilters();
        }
        else {
            this.showAllItems();
        }
    };
    BcCardSelectV2Behavior.prototype.setupPlaceHolder = function () {
        this.cardSelectInput = this.mySelf.querySelector(".".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_INPUT_CLASS_V2));
        if (this.cardSelectInput) {
            this.selectControl = this.mySelf.querySelector(".".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_CONTROL_CLASS_V2));
            this.placeHolder = (0, helpers_1.createElement)({
                element: common_constants_1.BcCommonConstants.LABEL_TAG,
                innerText: bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_MESSAGE_HOLDER,
                classList: this.placeHolderStyle,
                props: {
                    'for': this.mySelf.id + '-input',
                },
            });
            this.subtitleStyle.push(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_SUBTITLE_FONT);
            this.subtitle = (0, helpers_1.createElement)({
                element: common_constants_1.BcCommonConstants.P_TAG,
                innerText: bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_MESSAGE_SUBTITLE,
                classList: this.subtitleStyle,
            });
            this.cardSelectInput.appendChild(this.placeHolder);
            this.cardSelectInput.appendChild(this.subtitle);
            this.setIniText(this.iniText);
            this.setSubtitleText(this.subtitleText);
            var placeHolder = this.getFirstElementByClassName(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_PLACEHOLDER_CLASS_V2);
            if (!placeHolder) {
                this.placeHolder.classList.add("".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_PLACEHOLDER_CLASS_V2));
                this.setupSelectControlAccesibility(false);
                this.cardSelectInput.parentNode.insertBefore(this.placeHolder, this.cardSelectInput.nextSibling || null);
                this.cardSelectInput.style.display = common_constants_1.BcCommonConstants.NONE;
            }
            this.setListenersDropdown();
        }
    };
    BcCardSelectV2Behavior.prototype.setListenersDropdown = function () {
        var _this = this;
        window.addEventListener(bc_abstract_dropdown_constants_1._DROPDOWN_OPENED_EVENT, function (data) {
            _this.setupSelectControlAccesibility(true);
            _this.showPlaceHolder(data, false);
            _this.setPositionFixedContentFooter(common_constants_1.COMMON_CONSTANTS_NUMBERS.N15);
        });
        window.addEventListener(bc_abstract_dropdown_constants_1._DROPDOWN_CLOSED_EVENT, function (data) {
            _this.setupSelectControlAccesibility(false);
            _this.showPlaceHolder(data);
            _this.setupDropDownAccessibility();
            _this.setupCardAccessibility();
            _this.clearAllBcInputs();
            _this.showAllItems();
            _this.removeCardNoData();
        });
    };
    BcCardSelectV2Behavior.prototype.setupAccessibility = function () {
        var dropdownFooter = this.dropdownContent.querySelector("*[class~='".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_FOOTER_CLASS_V2, "']"));
        (0, helpers_1.addFocusable)(dropdownFooter, { "role": "button", "tabindex": "0" });
        var dropdownFooterLabel = dropdownFooter.querySelectorAll('label')[0];
        dropdownFooter.setAttribute("aria-labelledby", "".concat(dropdownFooterLabel.textContent));
        dropdownFooter.setAttribute("id", "".concat(this.mySelf.id, "-footer"));
        var dropdownBody = this.dropdownContent.querySelector("*[class~='".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_BODY_CLASS_V2, "']"));
        var cardsInfo = dropdownBody.querySelectorAll(".".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_INFO_CLASS_V2));
        cardsInfo === null || cardsInfo === void 0 ? void 0 : cardsInfo.forEach(function (item) {
            if (item.innerHTML.length > 0) {
                var ariaLabel = "Saldo de cuenta: ".concat(item.innerHTML.replace('$', ''), " pesos colombianos");
                item.setAttribute('aria-label', ariaLabel);
            }
        });
        this.setupBodyAccessibility();
        this.setupCardAccessibility();
        this.setupDropDownAccessibility();
    };
    BcCardSelectV2Behavior.prototype.setupBodyAccessibility = function () {
        var _this = this;
        this.mySelf.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            event.stopPropagation();
            if (_this.disabled) {
                return false;
            }
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_UP || event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_DOWN || event.key === common_constants_1.BcCommonConstants.KEY_EVENT_END || event.key === common_constants_1.BcCommonConstants.KEY_EVENT_HOME) {
                _this.processKeyDown(event);
            }
        });
    };
    BcCardSelectV2Behavior.prototype.getFocusItem = function () {
        var dropdownBody = this.mySelf.querySelector("*[class~='".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_BODY_CLASS_V2, "']"));
        return this.getCurrentItem(dropdownBody);
    };
    BcCardSelectV2Behavior.prototype.processKeyDown = function (event) {
        var _this = this;
        var nextItem;
        var dropdownBody = this.mySelf.querySelector("*[class~='".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_BODY_CLASS_V2, "']"));
        var currentItem = this.getCurrentItem(dropdownBody);
        if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_UP || event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_DOWN) {
            nextItem = this.processArrowUp(event, nextItem, currentItem);
            if (nextItem) {
                setTimeout(function () { _this.focusNextItem(currentItem, nextItem); }, bc_card_select_v2_constants_1.BcCardSelectConstants.TIME_OUT);
            }
        }
        else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_END || event.key === common_constants_1.BcCommonConstants.KEY_EVENT_HOME) {
            var items = dropdownBody.querySelectorAll(".".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_ITEM_CLASS_V2));
            nextItem = this.processArrowEnd(event, nextItem, items);
            if (nextItem) {
                setTimeout(function () { _this.focusNextItem(currentItem, nextItem); }, bc_card_select_v2_constants_1.BcCardSelectConstants.TIME_OUT);
            }
        }
    };
    BcCardSelectV2Behavior.prototype.getCurrentItem = function (dropdownBody) {
        if (dropdownBody.querySelectorAll("li.".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_OUTLINE_ELEMENT_V2)).length > 0) {
            return dropdownBody.querySelector("li.".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_OUTLINE_ELEMENT_V2));
        }
        else {
            if (!this.dropdownActive) {
                this.setupSelectControlAccesibility(true);
                this.openDrowndown();
            }
            var items = dropdownBody.querySelectorAll(".".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_ITEM_CLASS_V2));
            items[0].classList.add("".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_OUTLINE_ELEMENT_V2));
            return dropdownBody.querySelector("li.".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_OUTLINE_ELEMENT_V2));
        }
    };
    BcCardSelectV2Behavior.prototype.processArrowEnd = function (event, nextItem, items) {
        if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_END) {
            nextItem = items[items.length - 1];
        }
        else {
            nextItem = items[0];
        }
        return nextItem;
    };
    BcCardSelectV2Behavior.prototype.processArrowUp = function (event, nextItem, currentItem) {
        if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_UP) {
            nextItem = currentItem.previousElementSibling;
        }
        else {
            nextItem = currentItem.nextElementSibling;
        }
        return nextItem;
    };
    BcCardSelectV2Behavior.prototype.setupCardAccessibility = function () {
        if (this.activeElement) {
            this.selectControl.removeAttribute("tabindex");
            (0, helpers_1.addFocusable)(this.mySelf, { tabindex: '0' });
        }
        else {
            this.mySelf.removeAttribute("tabindex");
            (0, helpers_1.addFocusable)(this.selectControl, { tabindex: '0' });
        }
    };
    BcCardSelectV2Behavior.prototype.setupSelectControlAccesibility = function (expanded) {
        this.selectControl.setAttribute("aria-label", "Lista para seleccionar el producto, men\u00FA desplegable, ".concat(expanded ? 'Expandido' : 'Contraido'));
    };
    BcCardSelectV2Behavior.prototype.setupDropDownAccessibility = function () {
        var dropDown = this.mySelf.querySelector("em.".concat("arrow-direction"));
        (0, helpers_1.addFocusable)(dropDown, { tabindex: "0" });
    };
    BcCardSelectV2Behavior.prototype.focusNextItem = function (currentItem, nextItem) {
        currentItem.classList.remove("".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_OUTLINE_ELEMENT_V2));
        nextItem.classList.add("".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_OUTLINE_ELEMENT_V2));
        nextItem.focus();
    };
    BcCardSelectV2Behavior.prototype.showPlaceHolder = function (dropDownId, show) {
        if (show === void 0) { show = true; }
        var dropDown = this.mySelf.querySelector("[aria-controls=\"".concat(dropDownId.detail, "\"]"));
        this.input = this.mySelf.querySelector("".concat(common_constants_1.BcCommonConstants.INPUT_TAG, "[class=").concat(input_constants_1.INPUT, "]"));
        if (dropDown) {
            var selectedCard = this.mySelf.querySelector(".".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_ACTIVE_ITEM_CLASS_V2));
            if (!selectedCard) {
                if (!show) {
                    this.cardSelectInput.style.display = common_constants_1.BcCommonConstants.BLOCK;
                    this.placeHolder.style.display = common_constants_1.BcCommonConstants.NONE;
                    if (this.input) {
                        this.input.focus();
                    }
                }
                else {
                    this.cardSelectInput.style.display = common_constants_1.BcCommonConstants.NONE;
                    this.placeHolder.style.display = common_constants_1.BcCommonConstants.BLOCK;
                }
            }
            else {
                this.showSelectedCard(selectedCard, show);
            }
        }
    };
    BcCardSelectV2Behavior.prototype.showSelectedCard = function (selectedCard, show) {
        if (show === void 0) { show = true; }
        this.cardSelectInput.style.display = common_constants_1.BcCommonConstants.BLOCK;
        if (!show) {
            this.selectControl.style.display = common_constants_1.BcCommonConstants.FLEX;
            this.placeHolder.style.display = common_constants_1.BcCommonConstants.NONE;
            selectedCard.style.display = common_constants_1.BcCommonConstants.NONE;
            if (this.input) {
                this.input.focus();
            }
        }
        else {
            this.selectControl.style.display = common_constants_1.BcCommonConstants.NONE;
            selectedCard.style.display = common_constants_1.BcCommonConstants.BLOCK;
        }
    };
    BcCardSelectV2Behavior.prototype.setDefaultIndex = function (index) {
        this.defaultIndex = index;
    };
    BcCardSelectV2Behavior.prototype.setDefaultValue = function (value) {
        if (typeof value == 'undefined') {
            return;
        }
        if (!this.itemsConfig) {
            return;
        }
        var filtered = this.itemsConfig.find(function (e) { return e.value == value; });
        if (filtered) {
            var index = this.itemsConfig.indexOf(filtered);
            this.markItemByIndex(index);
            this.defaultIndex = index;
        }
    };
    BcCardSelectV2Behavior.prototype.getCurrentActiveItem = function () {
        if (!this.activeElement) {
            var activeCard = this.mySelf.querySelector("div[class=".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_ACTIVE_ITEM_CLASS_V2, "]"));
            if (activeCard) {
                var card = this.toCardComponent(activeCard, true);
                this.setActiveItem(card);
            }
        }
        return this.activeElement;
    };
    BcCardSelectV2Behavior.prototype.markItemByIndex = function (index) {
        var items = this.mySelf.querySelectorAll(("li[class~='".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_ITEM_CLASS_V2, "']")));
        var item = items[index];
        this.configSelectedEvent(index, item);
    };
    BcCardSelectV2Behavior.prototype.configSelectedEvent = function (i, item) {
        if (this.disabled) {
            return;
        }
        this.removeSelectedItem(item);
        this.showSelectedItem(item);
        this.closeDropdown();
        this.showAllItems();
        this.removeFilter();
        this.activeElement = this.itemsConfig[i];
        this.sortDropdownItems();
        this.hideArrow();
    };
    BcCardSelectV2Behavior.prototype.sortDropdownItems = function () {
        var dropdownBody = this.dropdownContent.querySelector("*[class~='".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_BODY_CLASS_V2, "']"));
        var ulChild = dropdownBody.firstChild;
        var liChildren = ulChild.childNodes;
        var arrayItems = Array.from(liChildren);
        if (arrayItems.length > 0) {
            arrayItems.forEach(function (currentValue, index) {
                if (currentValue['classList'] && currentValue['classList'].contains(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_SELECTED_ITEM_CLASS_V2)) {
                    arrayItems.unshift(currentValue);
                    arrayItems.splice(index + 1, 1);
                }
            });
        }
        arrayItems.forEach(function (li) {
            ulChild.appendChild(li);
        });
    };
    BcCardSelectV2Behavior.prototype.setEventListeners = function () {
        var _this = this;
        this.setListenerDropdownItems();
        this.mySelf.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
            _this.filterItemsEvent(event);
        });
        this.setListenerScroll();
        this.setListenerKeyDown();
        this.setListenerClick();
        var label = this.mySelf.querySelector("*[class~='".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_LABEL, "']"));
        this.input = this.mySelf.querySelector("".concat(common_constants_1.BcCommonConstants.INPUT_TAG, "[class=").concat(input_constants_1.INPUT, "]"));
        this.input.addEventListener(common_constants_1.BcCommonConstants.INPUT_TAG, function (event) {
            if (_this.input.value != '') {
                label.textContent = _this.getPlaceHolderText();
            }
            else {
                label.textContent = '';
            }
        });
    };
    BcCardSelectV2Behavior.prototype.setListenerDropdownItems = function () {
        var _this = this;
        this.dropdownItems.forEach(function (item) {
            item.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
                event.stopPropagation();
                event.preventDefault();
                _this.selectItemDropdown(item);
            });
            (0, helpers_1.addFocusable)(item, { tabindex: '0' }, { event: _this.configSelectedEvent.bind(_this, {}, _this.dropdownItems.indexOf(item), item) });
        });
    };
    BcCardSelectV2Behavior.prototype.selectItemDropdown = function (item) {
        this.configSelectedEvent(this.dropdownItems.indexOf(item), item);
        this.eventValueOutput(this.itemsConfig[this.dropdownItems.indexOf(item)]);
    };
    BcCardSelectV2Behavior.prototype.setListenerScroll = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.SCROLL, function (event) {
            var e = event.target;
            var scrollElement = e.className;
            if (scrollElement === bc_modal_constants_1.BcModalConstants.BC_MODAL_CONTENT) {
                _this.setupSelectControlAccesibility(false);
                _this.closeDropdown();
                _this.setPositionFixedContentBody();
                _this.setPositionFixedContentFooter(common_constants_1.COMMON_CONSTANTS_NUMBERS.N2);
            }
        }, true);
    };
    BcCardSelectV2Behavior.prototype.setListenerKeyDown = function () {
        var _this = this;
        this.mySelf.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            var isEnterKey = event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER;
            var isSpaceKey = event.code === common_constants_1.BcCommonConstants.KEY_EVENT_SPACE;
            if (_this.disabled) {
                return false;
            }
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ESCAPE) {
                _this.setupSelectControlAccesibility(false);
                _this.closeDropdown();
            }
            if ((isEnterKey || isSpaceKey) && !_this.dropdownActive) {
                _this.setupSelectControlAccesibility(true);
                _this.openDrowndown();
            }
            else if (isEnterKey && _this.dropdownActive) {
                _this.setupSelectControlAccesibility(false);
                var ELEMENT_NOT_DATA = _this.mySelf.querySelector("*[class~='".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_CONTENT_VISIBLE_V2, "']"));
                if (!ELEMENT_NOT_DATA) {
                    _this.selectItemDropdown(_this.getFocusItem());
                }
                _this.closeDropdown();
            }
        });
    };
    BcCardSelectV2Behavior.prototype.setListenerClick = function () {
        var _this = this;
        this.mySelf.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            if (_this.disabled) {
                return false;
            }
            _this.setupSelectControlAccesibility(true);
            _this.openDrowndown();
        });
        document.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            if (event.target instanceof Node && !_this.mySelf.contains(event.target)) {
                _this.setupSelectControlAccesibility(false);
                _this.closeDropdown();
                _this.resetComponent();
            }
        });
    };
    BcCardSelectV2Behavior.prototype.filterItemsEvent = function (event) {
        var _a;
        if (this.shouldSkipValidation(event)) {
            return;
        }
        if (typeof event.target.value === "string") {
            this.filterValue = event.target.value.toUpperCase();
            if (((_a = this.filterValue) === null || _a === void 0 ? void 0 : _a.length) >= bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_MIN_FILTER_CHA_V2) {
                this.filterDropdown();
            }
            else {
                this.showAllItems();
            }
            this.setIconNotData();
            this.returnValueInput(event.target.value);
        }
    };
    BcCardSelectV2Behavior.prototype.shouldSkipValidation = function (event) {
        var key = event.key;
        if (key === common_constants_1.BcCommonConstants.EVENT_TAP) {
            return true;
        }
        if (key === common_constants_1.BcCommonConstants.SHIFT) {
            return true;
        }
        var isKeyS = key.toLowerCase() === 's';
        var isOnlyShift = event.shiftKey;
        var isNoCtrlAltMeta = !event.ctrlKey && !event.altKey && !event.metaKey;
        if (isKeyS && isOnlyShift && isNoCtrlAltMeta) {
            return true;
        }
        var blockedKeys = [common_constants_1.BcCommonConstants.F2, common_constants_1.BcCommonConstants.F8, common_constants_1.BcCommonConstants.NUMLOCK, common_constants_1.BcCommonConstants.PRINTSCREEN];
        if (blockedKeys.includes(key)) {
            return true;
        }
        return false;
    };
    BcCardSelectV2Behavior.prototype.setPlaceHolderText = function (placeHolderMessage) {
        this.input = this.mySelf.querySelector("".concat(common_constants_1.BcCommonConstants.INPUT_TAG, "[class=").concat(input_constants_1.INPUT, "]"));
        this.input.setAttribute('placeholder', placeHolderMessage);
    };
    BcCardSelectV2Behavior.prototype.getPlaceHolderText = function () {
        return this.input.getAttribute('placeholder');
    };
    BcCardSelectV2Behavior.prototype.filterDropdown = function () {
        var inputValueElement = this.getFirstElementByClassName(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_INPUT_V2)['value'];
        var valueInput = inputValueElement.toUpperCase();
        if (this.input) {
            this.input.value = inputValueElement;
        }
        if (valueInput.length < bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_MIN_FILTER_CHA_V2) {
            this.showAllItems();
            this.removeCardNoData();
            return;
        }
        this.restoreFilters();
        this.filterItems(valueInput);
    };
    BcCardSelectV2Behavior.prototype.filterItems = function (valueInput) {
        var _this = this;
        var itemsFound = false;
        this.itemsConfig.forEach(function (config, i) {
            var thisString = _this.createFilterString(config);
            if (thisString.indexOf(valueInput) >= 0) {
                itemsFound = true;
                _this.highlightFilteredItem(i);
            }
        });
        if (itemsFound) {
            this.setupSelectControlAccesibility(true);
            this.openDrowndown();
        }
    };
    BcCardSelectV2Behavior.prototype.createFilterString = function (config) {
        var _this = this;
        var thisString;
        if (Array.isArray(this.fieldsToFilter) && this.fieldsToFilter.length > 0) {
            thisString = Object.keys(config)
                .filter(function (key) { return _this.fieldsToFilter.includes(key); })
                .map(function (key) { return typeof config[key] === common_constants_1.BcCommonConstants.STRING ? config[key].toUpperCase() : ''; })
                .join();
        }
        else {
            thisString = Object.values(config)
                .map(function (el) { return typeof el === common_constants_1.BcCommonConstants.STRING ? el.toUpperCase() : ''; })
                .join();
        }
        if (this.shouldIncludeSubtitle()) {
            var subTitle = config.subtittle.toString().toUpperCase();
            thisString = "".concat(thisString, ",").concat(subTitle);
        }
        return thisString;
    };
    BcCardSelectV2Behavior.prototype.shouldIncludeSubtitle = function () {
        return !Array.isArray(this.fieldsToFilter) || this.fieldsToFilter.includes(bc_card_select_v2_constants_1.BcCardSelectConstants.SUBTITLE);
    };
    BcCardSelectV2Behavior.prototype.highlightFilteredItem = function (index) {
        this.dropdownItems[index].classList.add(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_FILTERED_ITEMS_CLASS_V2);
        this.removeCardNoData();
    };
    BcCardSelectV2Behavior.prototype.returnValueInput = function (key) {
        return key;
    };
    BcCardSelectV2Behavior.prototype.getFirstElementByClassName = function (className) {
        var elements = this.mySelf.getElementsByClassName(className);
        var node = null;
        if (elements.length > 0) {
            node = elements[0];
        }
        return node;
    };
    BcCardSelectV2Behavior.prototype.showAllItems = function () {
        if (this.dropdownContent) {
            this.dropdownContent.classList.remove(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_FILTRABLE_ITEMS_CLASS_V2);
            this.removeCardNoData();
        }
    };
    BcCardSelectV2Behavior.prototype.restoreFilters = function () {
        if (this.dropdownContent) {
            this.dropdownContent.classList.add(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_FILTRABLE_ITEMS_CLASS_V2);
            this.dropdownItems.forEach(function (item) {
                item.classList.remove(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_FILTERED_ITEMS_CLASS_V2);
            });
        }
    };
    BcCardSelectV2Behavior.prototype.removeItemsSelection = function () {
        if (this.dropdownItems) {
            this.dropdownItems.forEach(function (item) {
                item.classList.remove(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_SELECTED_ITEM_CLASS_V2);
            });
        }
    };
    BcCardSelectV2Behavior.prototype.removeFilter = function () {
        if (this.input) {
            this.input.value = '';
        }
    };
    BcCardSelectV2Behavior.prototype.toCardComponent = function (element, isActive, toggleEvent) {
        var card = element.querySelector("div[class~=".concat(bc_card_product_v2_constants_1.BcCardProductConstants.CARD_MAIN_CLASS_V2, "]")).cloneNode(true);
        var cardItem = new bc_card_product_v2_behavior_1.BcCardProductV2Behavior();
        cardItem.setElement(card);
        if (toggleEvent) {
            cardItem.toggleAction = toggleEvent.bind(this);
        }
        cardItem.setUp();
        cardItem.setActive(isActive);
        return cardItem;
    };
    BcCardSelectV2Behavior.prototype.removeSelectedItem = function (item) {
        var selectedItem = this.mySelf.querySelector("div[class~=".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_ACTIVE_ITEM_CLASS_V2, "]"));
        this.removeItemsSelection();
        if (selectedItem) {
            selectedItem.remove();
        }
        this.mySelf.classList.remove(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_SELECTED_CLASS_V2);
        item.classList.add(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_SELECTED_ITEM_CLASS_V2);
        this.setActiveItem(null);
    };
    BcCardSelectV2Behavior.prototype.showSelectedItem = function (item) {
        var card = this.toCardComponent(item, true, this.clickToggleEvent);
        this.setActiveItem(card);
        this.mySelf.classList.add(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_SELECTED_CLASS_V2);
        this.mySelf.prepend((0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_ACTIVE_ITEM_CLASS_V2],
            children: [
                card.getMySelf(),
            ]
        }));
    };
    BcCardSelectV2Behavior.prototype.setActiveItem = function (card) {
        if (card) {
            this.activeElement = card.getConfig();
            this.BcCardProductV2Behavior = card;
            return;
        }
        this.activeElement = null;
        this.BcCardProductV2Behavior = null;
    };
    BcCardSelectV2Behavior.prototype.getDropdownFooter = function () {
        var dropdownFooter = this.dropdownContent.querySelector("*[class~='".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_FOOTER_CLASS_V2, "']"));
        if (dropdownFooter) {
            this.addDropdownButtonEventClick(dropdownFooter);
            return;
        }
        dropdownFooter = this.createDropDownFooter();
        this.dropdownContent.appendChild(dropdownFooter);
        this.addDropdownButtonEventClick(dropdownFooter);
    };
    BcCardSelectV2Behavior.prototype.createDropDownFooter = function () {
        var buttonConfig = this.dropdownButtonConfig;
        var divContent = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_FOOTER_ITEM_CLASS_V2],
            children: [
                (0, helpers_1.createElement)({
                    element: common_constants_1.BcCommonConstants.EM_TAG,
                    classList: [common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.ICON_SM_CLASS],
                    props: {
                        'aria-hidden': 'true'
                    },
                    innerText: buttonConfig.icon
                }),
                (0, helpers_1.createElement)({
                    element: common_constants_1.BcCommonConstants.LABEL_TAG,
                    innerText: buttonConfig.text
                }),
            ]
        });
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_FOOTER_CLASS_V2],
            children: [divContent]
        });
    };
    BcCardSelectV2Behavior.prototype.viewIconNotData = function (value) {
        var contentNotData = this.mySelf.querySelector("*[class~='".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_CONTENT_NOTDATA_V2, "']"));
        var contentNotDataVisible = this.mySelf.querySelector("*[class~='".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_CONTENT_VISIBLE_V2, "']"));
        if (value) {
            if (contentNotData) {
                contentNotData.classList.replace(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_CONTENT_NOTDATA_V2, bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_CONTENT_VISIBLE_V2);
            }
        }
        else {
            if (contentNotDataVisible) {
                contentNotDataVisible.classList.replace(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_CONTENT_VISIBLE_V2, bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_CONTENT_NOTDATA_V2);
            }
            var existingCard = this.dropdownContent.querySelector(common_constants_1.BcCommonConstants.CARD_SELECT_HORIZONTAL);
            if (existingCard) {
                existingCard.remove();
            }
        }
    };
    BcCardSelectV2Behavior.prototype.storeData = function (data) {
        this._dataTransfer = __assign({}, data);
    };
    BcCardSelectV2Behavior.prototype.preloadMainIconIfNeeded = function (data) {
        var _a;
        if (((_a = data === null || data === void 0 ? void 0 : data.mainIcon) === null || _a === void 0 ? void 0 : _a.type) === common_constants_1.BcCommonConstants.URL && data.mainIcon.url) {
            this.preloadImage(data.mainIcon.url);
        }
    };
    BcCardSelectV2Behavior.prototype.getInputLength = function () {
        var _a;
        var input = (_a = this.mySelf) === null || _a === void 0 ? void 0 : _a.querySelector('input');
        if (input instanceof HTMLInputElement) {
            return input.value.length;
        }
        return 0;
    };
    BcCardSelectV2Behavior.prototype.verifyData = function (finalData) {
        var _a;
        var dataReceived = finalData;
        if (!dataReceived) {
            return;
        }
        this.validateAndUpdateData(dataReceived);
        var alignment = (_a = dataReceived.alignment) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        if (alignment === common_constants_1.BcCommonConstants.BC_VERTICAL) {
            this.createDropDownNotEmpty(dataReceived);
        }
        else if (alignment === common_constants_1.BcCommonConstants.BC_HORIZONTAL) {
            this.createCardNoData(dataReceived);
        }
        this.shouldShowEmptyState();
    };
    BcCardSelectV2Behavior.prototype.removeCardNoData = function () {
        var existingCard = this.dropdownContent.querySelector(common_constants_1.BcCommonConstants.CARD_SELECT_HORIZONTAL);
        var existingCardVertical = this.dropdownContent.querySelector(common_constants_1.BcCommonConstants.BC_CARD_SELECT_NOTDATA);
        if (existingCard) {
            existingCard.remove();
        }
        if (existingCardVertical) {
            existingCardVertical.remove();
        }
    };
    BcCardSelectV2Behavior.prototype.validateAndUpdateData = function (data) {
        this.normalizeIconTypes(data);
        this.validateIconSources(data);
    };
    BcCardSelectV2Behavior.prototype.setIconNotData = function (data) {
        var _a;
        var MIN_INPUT_LENGTH = bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_MIN_FILTER_CHA_V2;
        this.storeIfValid(data);
        var dataToUse = (_a = this._dataTransfer) !== null && _a !== void 0 ? _a : this._data;
        var hasValidData = this.hasValidObject(dataToUse);
        var inputLength = this.getInputLength();
        var noResults = this.shouldShowEmptyState();
        if (inputLength >= MIN_INPUT_LENGTH) {
            if (noResults) {
                if (this.shouldShowDropdown(data, this._dataTransfer, this._data)) {
                    this.createDropDownNotdata();
                }
                if (hasValidData) {
                    this.verifyData(dataToUse);
                    this.preloadMainIconIfNeeded(dataToUse);
                }
            }
        }
    };
    BcCardSelectV2Behavior.prototype.storeIfValid = function (data) {
        if (this.hasValidObject(data)) {
            this.storeData(data);
        }
    };
    BcCardSelectV2Behavior.prototype.hasValidObject = function (obj) {
        return !!obj && Object.keys(obj).length > 0;
    };
    BcCardSelectV2Behavior.prototype.shouldShowDropdown = function () {
        var _this = this;
        var objects = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            objects[_i] = arguments[_i];
        }
        return !objects.some(function (obj) { return _this.hasValidObject(obj); });
    };
    BcCardSelectV2Behavior.prototype.shouldShowEmptyState = function () {
        var _a, _b;
        var filtrable = this.dropdownContent.classList.contains(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_FILTRABLE_ITEMS_CLASS_V2);
        var filteredCount = (_b = (_a = this.dropdownItems) === null || _a === void 0 ? void 0 : _a.filter(function (item) {
            return item.classList.contains(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_FILTERED_ITEMS_CLASS_V2);
        }).length) !== null && _b !== void 0 ? _b : 0;
        return (filtrable && filteredCount === 0) || this.itemsConfig.length === 0;
    };
    BcCardSelectV2Behavior.prototype.normalizeIconTypes = function (data) {
        var _a, _b, _c;
        if ((_a = data.leftIconName) === null || _a === void 0 ? void 0 : _a.name) {
            data.leftIconName.name = data.leftIconName.name.toLowerCase();
        }
        if ((_b = data.rightIconName) === null || _b === void 0 ? void 0 : _b.name) {
            data.rightIconName.name = data.rightIconName.name.toLowerCase();
        }
        if ((_c = data.mainIcon) === null || _c === void 0 ? void 0 : _c.type) {
            data.mainIcon.type = data.mainIcon.type.toLowerCase();
        }
    };
    BcCardSelectV2Behavior.prototype.validateIconSources = function (data) {
        var _a, _b;
        var validUrlPrefix = bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_VALID_URL;
        if (((_a = data.mainIcon) === null || _a === void 0 ? void 0 : _a.type) === common_constants_1.BcCommonConstants.URL) {
            var isValid = this.isValidUrl(data.mainIcon.url, validUrlPrefix);
            if (!isValid) {
                data.mainIcon.url = '';
            }
        }
        else if (((_b = data.mainIcon) === null || _b === void 0 ? void 0 : _b.type) === common_constants_1.BcCommonConstants.ICON) {
            var isURL = common_constants_1.BcCommonConstants.BC_HTTP_URL_REGEX.test(data.mainIcon.url);
            if (isURL) {
                data.mainIcon.url = '';
            }
        }
    };
    BcCardSelectV2Behavior.prototype.isValidUrl = function (url, prefix) {
        return typeof url === "string" && url.startsWith(prefix);
    };
    BcCardSelectV2Behavior.prototype.createIconIlustration = function (linkText, linkHref, leftIconName, rightIconName) {
        var _a, _b;
        return (0, helpers_1.createElement)({ element: common_constants_1.BcCommonConstants.HREF_TAG, classList: [
                common_constants_1.BcCommonConstants.BC_LINK_CLASS,
                bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_V2_LINK_LARGE
            ],
            props: (_a = {
                    id: common_constants_1.BcCommonConstants.BC_LINK_ICON,
                    href: linkHref,
                    target: '_blank'
                },
                _a[common_constants_1.BcCommonConstants.TABINDEX] = '0',
                _a[common_constants_1.BcCommonConstants.ARIA_LABEL] = linkText,
                _a[common_constants_1.BcCommonConstants.ARIA_LABELLEDBY] = common_constants_1.BcCommonConstants.BC_LINK_ICON,
                _a),
            children: [
                leftIconName ? this.createIconOrEm(leftIconName) : null,
                (0, helpers_1.createElement)({ element: common_constants_1.BcCommonConstants.SPAN_TAG, innerText: linkText,
                    props: (_b = {
                            id: common_constants_1.BcCommonConstants.BC_TEXT_LINK
                        },
                        _b[common_constants_1.BcCommonConstants.ARIA_LABEL] = linkText,
                        _b)
                }),
                rightIconName ? this.createIconOrEm(rightIconName) : null
            ].filter(Boolean)
        });
    };
    BcCardSelectV2Behavior.prototype.createIconOrEm = function (iconData) {
        var _a;
        return (0, helpers_1.createElement)({ element: common_constants_1.BcCommonConstants.EM_TAG,
            classList: [
                common_constants_1.BcCommonConstants.ICONS_CLASS,
                common_constants_1.BcCommonConstants.ICON_SM_CLASS
            ],
            innerText: iconData.name,
            props: (_a = {},
                _a[common_constants_1.BcCommonConstants.ARIA_LABEL] = iconData.name,
                _a)
        });
    };
    BcCardSelectV2Behavior.prototype.createIconElement = function (iconSrc) {
        var _a;
        return (0, helpers_1.createElement)({ element: common_constants_1.BcCommonConstants.EM_TAG,
            classList: [
                common_constants_1.BcCommonConstants.ICONS_CLASS,
                common_constants_1.BcCommonConstants.ICON_SM_CLASS
            ],
            innerText: iconSrc === null || iconSrc === void 0 ? void 0 : iconSrc.name,
            props: (_a = {},
                _a[common_constants_1.BcCommonConstants.TABINDEX] = '0',
                _a[common_constants_1.BcCommonConstants.ARIA_LABEL] = iconSrc === null || iconSrc === void 0 ? void 0 : iconSrc.name,
                _a),
        });
    };
    BcCardSelectV2Behavior.prototype.createLinkIcon = function (text, href, leftIconName, rightIconName) {
        var _a, _b;
        var _c, _d;
        var leftIconElement = ((_c = leftIconName === null || leftIconName === void 0 ? void 0 : leftIconName.name) === null || _c === void 0 ? void 0 : _c.trim())
            ? this.createIconElement(leftIconName) : null;
        var rightIconElement = ((_d = rightIconName === null || rightIconName === void 0 ? void 0 : rightIconName.name) === null || _d === void 0 ? void 0 : _d.trim())
            ? this.createIconElement(rightIconName) : null;
        var textElement = (0, helpers_1.createElement)({ element: common_constants_1.BcCommonConstants.SPAN_TAG, innerText: text,
            props: (_a = {
                    id: common_constants_1.BcCommonConstants.BC_TEXT_LINK
                },
                _a[common_constants_1.BcCommonConstants.ARIA_LABEL] = text,
                _a)
        });
        return (0, helpers_1.createElement)({ element: common_constants_1.BcCommonConstants.HREF_TAG, classList: [common_constants_1.BcCommonConstants.BC_LINK_CLASS, bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_V2_LINK_LARGE],
            children: [leftIconElement, textElement, rightIconElement].filter(Boolean),
            props: (_b = {
                    id: common_constants_1.BcCommonConstants.BC_LINK_ICON_CARD,
                    href: href,
                    target: '_blank'
                },
                _b[common_constants_1.BcCommonConstants.ARIA_LABEL] = text,
                _b[common_constants_1.BcCommonConstants.ARIA_LABELLEDBY] = common_constants_1.BcCommonConstants.BC_LINK_ICON_CARD,
                _b)
        });
    };
    BcCardSelectV2Behavior.prototype.createButtonsv = function (buttonConfig) {
        if (!buttonConfig || buttonConfig.length === 0) {
            return null;
        }
        var _a = buttonConfig[0], left = _a.left, right = _a.right;
        if (!(left === null || left === void 0 ? void 0 : left.trim()) && !(right === null || right === void 0 ? void 0 : right.trim())) {
            return null;
        }
        var buttonsContainer = this.createcontainerIconEmpty([
            bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_BUTTON_V2
        ]);
        if (left === null || left === void 0 ? void 0 : left.trim()) {
            var leftButton = this.createButtonElement(left, common_constants_1.BcCommonConstants.LEFT);
            buttonsContainer.appendChild(leftButton);
        }
        if (right === null || right === void 0 ? void 0 : right.trim()) {
            var rightButton = this.createButtonElement(right, common_constants_1.BcCommonConstants.RIGHT);
            buttonsContainer.appendChild(rightButton);
        }
        return buttonsContainer;
    };
    BcCardSelectV2Behavior.prototype.createButtonElement = function (text, position) {
        var _a;
        var id = position === common_constants_1.BcCommonConstants.LEFT
            ? common_constants_1.BcCommonConstants.BC_BTN_LEFT : common_constants_1.BcCommonConstants.BC_BTN_RIGTH;
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.BUTTON_TAG,
            classList: [position === common_constants_1.BcCommonConstants.LEFT ? bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_BUTTON_SECONDARY
                    : bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_BUTTON_PRIMARY, bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_BUTTON_SMALL],
            innerText: text,
            props: (_a = {
                    id: id,
                    type: common_constants_1.BcCommonConstants.ROLE_BUTTON
                },
                _a[common_constants_1.BcCommonConstants.TABINDEX] = '0',
                _a[common_constants_1.BcCommonConstants.ARIA_LABEL] = text,
                _a[common_constants_1.BcCommonConstants.ARIA_LABELLEDBY] = id,
                _a)
        });
    };
    BcCardSelectV2Behavior.prototype.createDropDownNotdata = function () {
        var existingCard = this.dropdownContent.querySelector(common_constants_1.BcCommonConstants.BC_CARD_SELECT_NOTDATA);
        if (this.shouldShowEmptyState()) {
            if (!existingCard) {
                var src = 'https://library-sdb.apps.bancolombia.com/bds/6.56.0/assets/icons/pictograms/pic-search-text.svg';
                var iconNotData = this.createIconNotData(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_ICON_NOTDATA_V2, src);
                var labelIconNotData = this.createlabelIconNotData(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_MESSAGENOTDATA_ALIGN, this.messageNotData);
                var newContainerIconNotData = this.createContainerCardNoData([bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_CONTENT_NOTDATA_V2], [iconNotData, labelIconNotData]);
                this.dropdownContent.appendChild(newContainerIconNotData);
                this.viewIconNotData(true);
            }
        }
        else {
            this.viewIconNotData(false);
        }
    };
    BcCardSelectV2Behavior.prototype.createcontainerIconEmpty = function (classList) {
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: __spreadArray(__spreadArray([], classList, true), [
                bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_PADDING
            ], false)
        });
    };
    BcCardSelectV2Behavior.prototype.createIconNotDataEmpty = function (defaultClass, src, size) {
        var _a;
        if (!src.trim()) {
            return null;
        }
        var preloadImg = new Image();
        preloadImg.src = src;
        var classListIconNotData = this.setArrayStyles(this.iconNotDataStyle, defaultClass);
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.IMG_TAG,
            classList: __spreadArray(__spreadArray([], classListIconNotData, true), [
                common_constants_1.BcCommonConstants.CARD_SELECT_V2_SIZE + size
            ], false),
            props: (_a = {},
                _a[common_constants_1.BcCommonConstants.TABINDEX] = '0',
                _a[common_constants_1.BcCommonConstants.SRC] = src,
                _a[common_constants_1.BcCommonConstants.ROLE] = common_constants_1.BcCommonConstants.IMG_TAG,
                _a[common_constants_1.BcCommonConstants.ALT] = bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_MESSAGE_NOT_FOUND,
                _a[common_constants_1.BcCommonConstants.ARIA_LABEL] = common_constants_1.BcCommonConstants.ILUSTRATION,
                _a),
        });
    };
    BcCardSelectV2Behavior.prototype.createIlustrationNotData = function (defaultClass, nameIcon, size) {
        var _a;
        if (!nameIcon.trim()) {
            return null;
        }
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.EM_TAG,
            classList: [
                common_constants_1.BcCommonConstants.ICONS_CLASS,
                common_constants_1.BcCommonConstants.CARD_SELECT_V2_SIZE + size,
            ],
            innerText: nameIcon,
            props: (_a = {},
                _a[common_constants_1.BcCommonConstants.TABINDEX] = '0',
                _a[common_constants_1.BcCommonConstants.ARIA_LABEL] = nameIcon,
                _a[common_constants_1.BcCommonConstants.ROLE] = common_constants_1.BcCommonConstants.ICON,
                _a[common_constants_1.BcCommonConstants.ALT] = bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_MESSAGE_NOT_FOUND,
                _a),
        });
    };
    BcCardSelectV2Behavior.prototype.createlabelIconVertical = function (defaultClass, innerText) {
        var _a;
        if (!innerText.trim()) {
            return null;
        }
        var classListLabelIconNotData = this.setArrayStyles(this.labelNotDataStyle, defaultClass);
        var generatedId = common_constants_1.BcCommonConstants.BC_LABEL_ICON;
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.P_TAG,
            classList: __spreadArray(__spreadArray([], classListLabelIconNotData, true), [
                bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_PADDING_HORIZONTAL
            ], false),
            innerText: innerText,
            props: (_a = {
                    id: generatedId
                },
                _a[common_constants_1.BcCommonConstants.TABINDEX] = '0',
                _a.role = common_constants_1.BcCommonConstants.TEXT,
                _a[common_constants_1.BcCommonConstants.ARIA_LABEL] = innerText,
                _a[common_constants_1.BcCommonConstants.ARIA_LABELLEDBY] = generatedId,
                _a.style = 'text-align: center',
                _a),
        });
    };
    BcCardSelectV2Behavior.prototype.createlabelIconHorizontal = function (defaultClass, innerText) {
        var _a;
        if (!innerText.trim()) {
            return null;
        }
        var classListLabelIconNotData = this.setArrayStyles(this.labelNotDataStyle, defaultClass);
        var generatedId = common_constants_1.BcCommonConstants.BC_LABEL_HORIZONTAL;
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.P_TAG,
            classList: __spreadArray(__spreadArray([], classListLabelIconNotData, true), [
                bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_PADDING_TOP
            ], false),
            innerText: innerText,
            props: (_a = {
                    id: generatedId
                },
                _a[common_constants_1.BcCommonConstants.TABINDEX] = '0',
                _a.role = 'text',
                _a[common_constants_1.BcCommonConstants.ARIA_LABEL] = innerText,
                _a[common_constants_1.BcCommonConstants.ARIA_LABELLEDBY] = generatedId,
                _a),
        });
    };
    BcCardSelectV2Behavior.prototype.createIconNotData = function (defaultClass, src) {
        var classListIconNotData = this.setArrayStyles(this.iconNotDataStyle, defaultClass);
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.IMG_TAG,
            classList: classListIconNotData,
            props: {
                'src': src
            },
        });
    };
    BcCardSelectV2Behavior.prototype.createlabelIconNotData = function (defaultClass, innerText) {
        var classListLabelIconNotData = this.setArrayStyles(this.labelNotDataStyle, defaultClass);
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.P_TAG,
            classList: classListLabelIconNotData,
            innerText: innerText
        });
    };
    BcCardSelectV2Behavior.prototype.createlabelTextHorizontal = function (defaultClass, innerText) {
        var _a;
        if (!innerText.trim()) {
            return null;
        }
        var classListLabelIconNotData = this.setArrayStyles(this.labelNotDataStyle, defaultClass);
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.P_TAG,
            classList: __spreadArray(__spreadArray([], classListLabelIconNotData, true), [bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_PADDING], false),
            innerText: innerText,
            props: (_a = {},
                _a[common_constants_1.BcCommonConstants.TABINDEX] = '0',
                _a.role = common_constants_1.BcCommonConstants.TEXT,
                _a[common_constants_1.BcCommonConstants.ARIA_LABEL] = innerText,
                _a),
        });
    };
    BcCardSelectV2Behavior.prototype.createlabelTextVertical = function (defaultClass, innerText) {
        var _a;
        if (!innerText.trim()) {
            return null;
        }
        var classListLabelIconNotData = this.setArrayStyles(this.labelNotDataStyle, defaultClass);
        var generatedId = common_constants_1.BcCommonConstants.BC_LABEL_VERTICAL;
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.P_TAG,
            classList: __spreadArray(__spreadArray([], classListLabelIconNotData, true), [
                bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_PADDING_lABEL
            ], false),
            innerText: innerText,
            props: (_a = {
                    id: generatedId
                },
                _a[common_constants_1.BcCommonConstants.TABINDEX] = '0',
                _a.role = common_constants_1.BcCommonConstants.INPUT_TEXT_TYPE,
                _a[common_constants_1.BcCommonConstants.ARIA_LABEL] = innerText,
                _a[common_constants_1.BcCommonConstants.ARIA_LABELLEDBY] = generatedId,
                _a),
        });
    };
    BcCardSelectV2Behavior.prototype.createDropDownNotEmpty = function (dataReceived) {
        var existingCard = this.dropdownContent.querySelector(common_constants_1.BcCommonConstants.BC_CARD_SELECT_NOTDATA);
        if (this.shouldShowEmptyState()) {
            if (!existingCard) {
                var ilustracion = this.getIlustration(dataReceived);
                var labelIconNotData = this.getLabelIconNotData(dataReceived.messageTittle);
                var labelIconNotDatav2 = this.getLabelIconVerticalSub(dataReceived.messageSubTittle);
                var linkContainer = this.getLinkContainer(dataReceived);
                var buttonsContainer = this.getButtonsContainer(dataReceived);
                var elementos = [
                    ilustracion,
                    labelIconNotData,
                    labelIconNotDatav2,
                    buttonsContainer,
                    linkContainer
                ].filter(function (el) { return el !== null; });
                var newContainerIconNotData = this.createContainerCardNoData([bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_CONTENT_NOTDATA_V2], __spreadArray([], elementos, true));
                newContainerIconNotData.style.padding = bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_CARD;
                this.dropdownContent.appendChild(newContainerIconNotData);
                this.viewIconNotData(true);
            }
        }
        else {
            this.viewIconNotData(false);
        }
    };
    BcCardSelectV2Behavior.prototype.getIlustration = function (dataReceived) {
        var _a, _b;
        if (((_a = dataReceived.mainIcon) === null || _a === void 0 ? void 0 : _a.type) === common_constants_1.BcCommonConstants.URL) {
            return this.createIconNotDataEmpty(common_constants_1.BcCommonConstants.ICONS_CLASS, dataReceived.mainIcon.url, dataReceived.mainIcon.size);
        }
        if (((_b = dataReceived.mainIcon) === null || _b === void 0 ? void 0 : _b.type) === common_constants_1.BcCommonConstants.ICON) {
            return this.createIlustrationNotData(common_constants_1.BcCommonConstants.ICONS_CLASS, dataReceived.mainIcon.url, dataReceived.mainIcon.size);
        }
        return null;
    };
    BcCardSelectV2Behavior.prototype.getLabelIconNotData = function (message) {
        return this.createlabelIconVertical(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_EMPTY_TITLE, message);
    };
    BcCardSelectV2Behavior.prototype.getLabelIconNotDataSub = function (message) {
        return this.createlabelTextHorizontal(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_EMPTY_SUBTITLE, message);
    };
    BcCardSelectV2Behavior.prototype.getLabelIconVertical = function (message) {
        return this.createlabelIconHorizontal(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_EMPTY_TITLE, message);
    };
    BcCardSelectV2Behavior.prototype.getLabelIconVerticalSub = function (message) {
        return this.createlabelTextVertical(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_EMPTY_SUBTITLE, message);
    };
    BcCardSelectV2Behavior.prototype.getLinkContainer = function (dataReceived) {
        var leftIconName = dataReceived.leftIconName, rightIconName = dataReceived.rightIconName, linkText = dataReceived.linkText, linkHref = dataReceived.linkHref;
        var normalizedLeft = __assign(__assign({}, leftIconName), { type: common_constants_1.BcCommonConstants.ICON });
        var normalizedRight = __assign(__assign({}, rightIconName), { type: common_constants_1.BcCommonConstants.ICON });
        if (!(linkText === null || linkText === void 0 ? void 0 : linkText.trim())) {
            return null;
        }
        return this.createLinkIcon(linkText !== null && linkText !== void 0 ? linkText : "", linkHref !== null && linkHref !== void 0 ? linkHref : "#", normalizedLeft, normalizedRight);
    };
    BcCardSelectV2Behavior.prototype.preloadImage = function (url) {
        var preloadLink = document.createElement('link');
        preloadLink.rel = common_constants_1.BcCommonConstants.BC_PRELOAD;
        preloadLink.as = common_constants_1.BcCommonConstants.IMAGE;
        preloadLink.href = url;
        preloadLink.type = common_constants_1.BcCommonConstants.BC_PRELOAD_SVG;
        document.head.appendChild(preloadLink);
    };
    BcCardSelectV2Behavior.prototype.getButtonsContainer = function (dataReceived) {
        var _a, _b;
        return this.createButtonsv([
            { left: (_a = dataReceived.buttonConfig) === null || _a === void 0 ? void 0 : _a.left, right: (_b = dataReceived.buttonConfig) === null || _b === void 0 ? void 0 : _b.right }
        ]);
    };
    BcCardSelectV2Behavior.prototype.isAngularEnviroment = function () {
        return typeof window !== 'undefined' && typeof window['ng'] !== 'undefined';
    };
    BcCardSelectV2Behavior.prototype.setArrayStyles = function (classList, defaultClass) {
        var arrayClass = [];
        arrayClass.push(defaultClass);
        if (classList) {
            classList.forEach(function (element) {
                arrayClass.push(element);
            });
        }
        return arrayClass;
    };
    BcCardSelectV2Behavior.prototype.addDropdownButtonEventClick = function (footerElement) {
        var _this = this;
        footerElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            _this.dropdownButtonConfig.event(event);
            event.stopPropagation();
            _this.setupSelectControlAccesibility(false);
            _this.closeDropdown();
        });
        (0, helpers_1.addFocusable)(footerElement, {}, { event: this.dropdownButtonConfig.event });
    };
    BcCardSelectV2Behavior.prototype.getDropdownBody = function () {
        var dropdownBody = this.dropdownContent.querySelector("*[class~='".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_BODY_CLASS_V2, "']"));
        if (!dropdownBody) {
            this.dropdownContent.appendChild((0, helpers_1.createElement)({
                element: common_constants_1.BcCommonConstants.DIV_TAG,
                classList: [bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_BODY_CLASS_V2]
            }));
        }
    };
    BcCardSelectV2Behavior.prototype.getDropdownParent = function () {
        var dropdownParent = this.mySelf.querySelector("*[class~='".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_CLASS_V2, "']"));
        if (dropdownParent) {
            this.dropdownContent = dropdownParent;
            return;
        }
        var idCardSelect = this.mySelf.getAttribute('id');
        var contentId = "".concat(idCardSelect, "-content");
        dropdownParent = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_CLASS_V2],
            props: {
                id: contentId,
            },
        });
        this.mySelf.appendChild(dropdownParent);
        this.dropdownContent = dropdownParent;
    };
    BcCardSelectV2Behavior.prototype.cleanItems = function () {
        this.itemsConfig = [];
        this.dropdownItems = [];
    };
    BcCardSelectV2Behavior.prototype.createCardItem = function (data) {
        var cardDiv = (0, helpers_1.createElement)({ element: common_constants_1.BcCommonConstants.DIV_TAG, classList: [bc_card_product_v2_constants_1.BcCardProductConstants.CARD_MAIN_CLASS_V2],
        });
        var cardItem = new bc_card_product_v2_behavior_1.BcCardProductV2Behavior();
        cardItem.setElement(cardDiv);
        cardItem.setConfig(data);
        cardItem.setUp();
        cardItem.build();
        return (0, helpers_1.createElement)({ element: common_constants_1.BcCommonConstants.LI_TAG,
            classList: [this.config.itemClass], children: [cardItem.getMySelf()],
            props: {
                value: data.value
            }
        });
    };
    BcCardSelectV2Behavior.prototype.setMaxHeightDropdown = function (maxHeightDropdown) {
        this.maxHeightDropdown = maxHeightDropdown;
        var contentItems = this.mySelf.querySelector("*[class~='".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_CONTENT_ITEM_CLASS, "']"));
        if (contentItems) {
            contentItems.style.maxHeight = maxHeightDropdown + 'px';
        }
    };
    BcCardSelectV2Behavior.prototype.setHideArrowState = function (hideArrowIcon) {
        this.hideArrowIcon = hideArrowIcon;
        this.hideArrow();
    };
    BcCardSelectV2Behavior.prototype.setIniText = function (iniText) {
        this.iniText = iniText;
        if (this.placeHolder && iniText) {
            this.placeHolder.innerHTML = this.iniText;
        }
    };
    BcCardSelectV2Behavior.prototype.setPlaceHolderStyle = function (placeHolderStyle) {
        this.placeHolderStyle = placeHolderStyle;
    };
    BcCardSelectV2Behavior.prototype.setSubtitleText = function (subtitleText) {
        this.subtitleText = subtitleText;
        if (this.subtitle && subtitleText) {
            this.subtitle.innerHTML = subtitleText;
        }
    };
    BcCardSelectV2Behavior.prototype.setSubtitleStyleStyle = function (subtitleStyle) {
        this.subtitleStyle = subtitleStyle;
    };
    BcCardSelectV2Behavior.prototype.setComponentStyle = function (componentStyle) {
        if (componentStyle.titleStyle) {
            this.setPlaceHolderStyle(componentStyle.titleStyle);
        }
        if (componentStyle.subtitleStyle) {
            this.setSubtitleStyleStyle(componentStyle.subtitleStyle);
        }
        if (componentStyle.iconNotDataStyle) {
            this.setIconNotDataStyle(componentStyle.iconNotDataStyle);
        }
        if (componentStyle.labelNotDataStyle) {
            this.setLabelIconNotDataStyle(componentStyle.labelNotDataStyle);
        }
        if (componentStyle.setMaxHeightDropdown) {
            this.setMaxHeightDropdown(componentStyle.setMaxHeightDropdown);
        }
    };
    BcCardSelectV2Behavior.prototype.hideArrow = function () {
        var arrow = this.mySelf.querySelector("*[class~='arrow-direction']");
        if (this.hideArrowIcon) {
            arrow['style'].display = common_constants_1.BcCommonConstants.NONE;
        }
        else {
            arrow['style'].display = common_constants_1.BcCommonConstants.BLOCK;
        }
    };
    BcCardSelectV2Behavior.prototype.hideDropdown = function (hide) {
        var dropdownFooter = this.mySelf.querySelector("*[class~='".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_FOOTER_CLASS_V2, "']"));
        if (dropdownFooter && hide) {
            dropdownFooter.style.display = common_constants_1.BcCommonConstants.NONE;
        }
        else if (dropdownFooter && !hide) {
            dropdownFooter.style.display = common_constants_1.BcCommonConstants.BLOCK;
        }
        this.firstHeight = bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_MAX_HEIGHT;
    };
    BcCardSelectV2Behavior.prototype.setMessageNotData = function (messageNotData) {
        if (messageNotData.length > 0) {
            this.messageNotData = messageNotData;
        }
    };
    BcCardSelectV2Behavior.prototype.setIconNotDataStyle = function (iconNotDataStyle) {
        this.iconNotDataStyle = iconNotDataStyle;
    };
    BcCardSelectV2Behavior.prototype.setLabelIconNotDataStyle = function (labelIconNotDataStyle) {
        this.labelNotDataStyle = labelIconNotDataStyle;
    };
    BcCardSelectV2Behavior.prototype.eventValueOutput = function (activeElement) {
        return activeElement;
    };
    BcCardSelectV2Behavior.prototype.resetComponent = function () {
        this.clearAllBcInputs();
        this.restoreFilters();
        this.removeItemsSelection();
        this.removeFilter();
        this.viewIconNotData('');
        this.showAllItems();
        this.removeCardNoData();
        var activeElement = this.mySelf.querySelector(".".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_ACTIVE_ITEM_CLASS_V2));
        if (activeElement) {
            activeElement.remove();
        }
        this.selectControl = this.mySelf.querySelector(".".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_CONTROL_CLASS_V2));
        if (this.selectControl) {
            this.selectControl.style.display = common_constants_1.BcCommonConstants.FLEX;
        }
        var label = this.mySelf.querySelector("label[class~='".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_LABEL, "']"));
        if (label) {
            label.textContent = '';
        }
        this.closeDropdown();
        this.setupSelectControlAccesibility(false);
    };
    BcCardSelectV2Behavior.prototype.clearAllBcInputs = function () {
        var inputs = document.querySelectorAll(common_constants_1.BcCommonConstants.BC_INPUT);
        inputs.forEach(function (input) {
            input.value = '';
        });
    };
    BcCardSelectV2Behavior.prototype.setPositionFixedContentBody = function () {
        if (this.dropdownContent) {
            var contentBody = this.dropdownContent.querySelector("*[class~='".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_BODY_CLASS_V2, "']"));
            var coords = this.mySelf.getBoundingClientRect();
            contentBody['style'].top = coords.top + coords.height - common_constants_1.COMMON_CONSTANTS_NUMBERS.N2 + 'px';
        }
    };
    BcCardSelectV2Behavior.prototype.setPositionFixedContentFooter = function (marginTopFooter) {
        if (this.dropdownContent) {
            var contentFooter = this.dropdownContent.querySelector("*[class~='".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_FOOTER_CLASS_V2, "']"));
            var contentBody = this.dropdownContent.querySelector("*[class~='".concat(bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_DROPDOWN_BODY_CLASS_V2, "']"));
            if (contentFooter) {
                var computedStyle = window.getComputedStyle(contentFooter);
                var position = computedStyle.position;
                if (position === bc_card_select_v2_constants_1.BcCardSelectConstants.POSITION_FIXED) {
                    var coords = this.mySelf.getBoundingClientRect();
                    contentFooter['style'].top =
                        coords.top + coords.height + contentBody.clientHeight - marginTopFooter + 'px';
                }
            }
        }
    };
    BcCardSelectV2Behavior.prototype.disableDropdown = function (hide) {
        if (hide === void 0) { hide = false; }
        this._noOpenDropdown = hide;
        this.config.noOpenDropdown = hide;
    };
    BcCardSelectV2Behavior.prototype.createContainerCardNoData = function (classList, children) {
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: classList,
            children: children
        });
    };
    BcCardSelectV2Behavior.prototype.createCardNoData = function (dataReceived) {
        var existingCard = this.dropdownContent.querySelector(common_constants_1.BcCommonConstants.CARD_SELECT_HORIZONTAL);
        if (this.shouldShowEmptyState()) {
            if (!existingCard) {
                var ilustracion = this.getIlustrationHorizontal(dataReceived);
                var title = this.getLabelIconVertical(dataReceived.messageTittle);
                var paragraph = this.getLabelIconNotDataSub(dataReceived.messageSubTittle);
                var linkContainer = this.getLinkContainer(dataReceived);
                var buttonsContainer = this.getButtonsContainer(dataReceived);
                var elementos = [title, paragraph, buttonsContainer, linkContainer]
                    .filter(function (el) { return el !== null; });
                var contentCard = this.createContainerCardNoData([bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_CONTAINER_HORIZONTAL], __spreadArray([], elementos, true));
                contentCard.setAttribute(common_constants_1.BcCommonConstants.CARD_SELECT_DATA_POSITION, common_constants_1.BcCommonConstants.CARD_SELECT_POSITION);
                var cardContainer = this.createContainerCardNoData([common_constants_1.BcCommonConstants.CARD_SELECT_HORIZON], [ilustracion, contentCard].filter(Boolean));
                cardContainer.setAttribute(common_constants_1.BcCommonConstants.TABINDEX, "0");
                cardContainer.setAttribute(common_constants_1.BcCommonConstants.ID, common_constants_1.BcCommonConstants.BC_NOT_DATA_CARD);
                this.dropdownContent.appendChild(cardContainer);
            }
        }
    };
    BcCardSelectV2Behavior.prototype.getIlustrationHorizontal = function (dataReceived) {
        var _a, _b;
        if (((_a = dataReceived.mainIcon) === null || _a === void 0 ? void 0 : _a.type) === common_constants_1.BcCommonConstants.URL) {
            return this.createIconNotDataHorizontal(common_constants_1.BcCommonConstants.ICONS_CLASS, dataReceived.mainIcon.url, dataReceived.mainIcon.size);
        }
        if (((_b = dataReceived.mainIcon) === null || _b === void 0 ? void 0 : _b.type) === common_constants_1.BcCommonConstants.ICON) {
            return this.createIlustrationHorizontal(common_constants_1.BcCommonConstants.ICONS_CLASS, dataReceived.mainIcon.url, dataReceived.mainIcon.size);
        }
        return null;
    };
    BcCardSelectV2Behavior.prototype.createIconNotDataHorizontal = function (defaultClass, src, size) {
        var _a;
        if (!src.trim()) {
            return null;
        }
        var classListIconNotData = this.setArrayStyles(this.iconNotDataStyle, defaultClass);
        return (0, helpers_1.createElement)({ element: common_constants_1.BcCommonConstants.IMG_TAG, classList: __spreadArray(__spreadArray([], classListIconNotData, true), [
                common_constants_1.BcCommonConstants.CARD_SELECT_V2_SIZE + size,
                bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_ILUSTRATION
            ], false),
            props: (_a = {},
                _a[common_constants_1.BcCommonConstants.TABINDEX] = '0',
                _a[common_constants_1.BcCommonConstants.SRC] = src,
                _a[common_constants_1.BcCommonConstants.ROLE] = common_constants_1.BcCommonConstants.IMG_TAG,
                _a[common_constants_1.BcCommonConstants.ALT] = bc_card_select_v2_constants_1.BcCardSelectConstants.CARD_SELECT_MESSAGE_NOT_FOUND,
                _a[common_constants_1.BcCommonConstants.ARIA_LABEL] = common_constants_1.BcCommonConstants.ILUSTRATION,
                _a)
        });
    };
    BcCardSelectV2Behavior.prototype.createIlustrationHorizontal = function (defaultClass, nameIcon, size) {
        var _a;
        if (!nameIcon.trim()) {
            return null;
        }
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.EM_TAG,
            classList: [
                common_constants_1.BcCommonConstants.ICONS_CLASS,
                common_constants_1.BcCommonConstants.CARD_SELECT_V2_SIZE + size
            ],
            innerText: nameIcon,
            props: (_a = {},
                _a[common_constants_1.BcCommonConstants.ARIA_LABEL] = nameIcon,
                _a[common_constants_1.BcCommonConstants.ALT] = nameIcon,
                _a),
        });
    };
    return BcCardSelectV2Behavior;
}(bc_abstract_dropdown_behavior_1.BcAbstractDropdownBehavior));
exports.BcCardSelectV2Behavior = BcCardSelectV2Behavior;
